export const translations = {
  de: {
    nav: {
      home: "Home",
      services: "Bausteine",
      eroeffnung: "Eröffnung",
      process: "Prozess",
      packages: "Investition",
      faq: "FAQ",
      industries: "Versorgungsformen",
      contact: "Kontakt",
      cta: "Erstgespräch",
      menuOpen: "Menü öffnen",
      menuClose: "Menü schließen",
    },
    hero: {
      eyebrow: "Pflege-Markenaufbau & Wachstum",
      l1: "Wir machen Ihren Dienst",
      l2: "zur Marke, die man kennt",
      l3: "und wiedererkennt.",
      l4: "Mehr Patienten. Mehr Personal.",
      sub: "Jeder Pflegedienst, der Menschen hilft, verdient eine Marke, die man in der Region kennt — und einen Kalender, der voll ist. Wir bauen beides: Marke, Website, Google & Meta-Anzeigen, Systeme und QM. Aus einer Hand. Von Leuten, die selbst eine Pflege-Akademie von null gebaut haben.",
      cta1: "Kostenlose Potenzial-Analyse",
      cta2: "Die vier Bausteine",
      chips: ["Marke & Wiedererkennung", "Mehr Patienten", "Mehr Personal"],
      side: "Ihre Marke. Ihre Region. Ihre vollen Touren.",
      meta: "Paphos, Zypern · Deutsch & English",
      imgAlt: "Pflege-Homepage auf Laptop und Smartphone in dunklem Premium-Arbeitszimmer",
      sim: {
        title: "Potenzial-Rechner",
        sub: "Wo steht Ihr Dienst heute?",
        careType: "Versorgungsform",
        careOptions: ["Ambulanter Dienst", "Tagespflege", "Intensivpflege", "Voll-/teilstationär"],
        city: "Einzugsgebiet",
        cityOptions: ["Kleinstadt (unter 20.000)", "Mittelstadt (20.000–75.000)", "Großstadt (über 75.000)"],
        current: "Anfragen pro Monat heute",
        currentHint: "Schätzung reicht — Sie kennen Ihr Telefon.",
        resultLabel: "Realistisch möglich mit Joudi",
        resultHint: "Ehrliche Ersteinschätzung aus Anfragenlage, Region und Versorgungsform. Was Ihre echten Zahlen hergeben, klärt das Erstgespräch — unverbindlich.",
        cta: "Potenzial besprechen",
        perMonth: "Anfragen / Monat",
      },
    },
    marquee: ["Lokale Pflege-Marke", "Mehr Patienten", "Qualifiziertes Personal", "Sichtbar vorne bei Google", "Repräsentative Webseite", "Systematisches Wachstum", "Markenaufbau", "Volle Touren"],
    services: {
      eyebrow: "Die vier Bausteine",
      title: "Vom unbekannten Dienst zur echten Pflege-Marke.",
      sub: "Jeder Baustein ist einzeln buchbar — zusammen entsteht Ihr komplettes Wachstumssystem. Erst der Engpass, dann der Rest.",
      more: "Baustein anfragen",
      items: [
        { id: "marke", icon: "monitor", title: "Markenaufbau & Regionale Sichtbarkeit", desc: "Man muss Sie kennen und wiedererkennen: ein Gesicht, ein Name, ein Erscheinungsbild — in Ihrer Region omnipräsent, bei Google vorne.", checks: ["Marken-Design, das man wiedererkennt", "Sichtbar vorne bei Google in Ihrer Region — Google Business & Maps", "System für laufend echte Bewertungen zufriedener Angehöriger", "Social Media, die Ihre Region erreicht"] },
        { id: "patienten", icon: "megaphone", title: "Neupatienten-Wachstum & Auslastung", desc: "Ihr Engpass sind nicht die Pflegeplätze — es sind die Anfragen. Wir besetzen die Suche von Angehörigen und bauen Zuweiser-Quellen aus.", checks: ["Google & Meta Ads für Patienten-Anfragen", "Empfehlungsquellen: Ärzte, Kliniken, Sozialstationen", "Landingpages, die Anrufe statt Klicks bringen", "Anfragen-Tracking: Sie sehen, was ankommt"] },
        { id: "personal", icon: "users", title: "Mitarbeiter-Recruiting & Arbeitgebermarke", desc: "Ohne Personal kein Wachstum. Dieselbe Maschine, zweites Publikum: Wir machen Ihren Dienst zum attraktiven Arbeitgeber in der Region.", checks: ["Personal-Kampagnen für Pflegekräfte", "Arbeitgebermarke, für die man bleiben will", "Karriereseite & Bewerbungsprozess, der führt", "Sichtbarkeit dort, wo Fachkräfte suchen"] },
        { id: "systeme", icon: "database", title: "Systeme, Digitalisierung & QM", desc: "Volle Kalender brauchen reibungslose Abläufe dahinter — und eine Prüfung, die Sie entspannt bestehen.", checks: ["Anbindung Ihrer Abrechnungssoftware", "CRM für Anfragen, Angehörige & Zuweiser", "Digitale Vorgänge statt Papierstapeln", "QM-Handbuch & Prüfung durch den Medizinischen Dienst (früher MDK)"] },
      ],
    },
    vergleich: {
      eyebrow: "Vorher / Nachher",
      title: "Eine gute Pflege-Homepage erkennt man sofort. Eine schlechte leider auch.",
      sub: "80 % der Angehörigen suchen am Handy nach einem Pflegedienst — und entscheiden in Sekunden. Der Unterschied zwischen diesen beiden Seiten ist der Unterschied zwischen stillstehendem Telefon und vollen Touren.",
      note: "Alle gezeigten Homepages sind fiktive Beispiele zur Veranschaulichung.",
      bad: {
        badge: "Vorher",
        url: "www.beispiel-pflegedienst.de",
        name: "Pflegedienst Mustermann",
        headline: "Herzlich Willkommen auf unserer Homepage!!!",
        welcome: "Schön, dass Sie da sind",
        counter: "Besucher: 004217",
        neu: "NEU!",
        nav: ["Start", "Über uns", "Kontakt", "Gästebuch"],
        body: "Wir sind ein Pflegedienst und bieten häusliche Pflege, Betreuung, Verhinderungspflege, Haushaltshilfe und vieles mehr. Klicken Sie sich durch unsere Seite und erfahren Sie mehr über unsere Angebote. Unsere Seite befindet sich noch im Aufbau. Letzte Aktualisierung: 12.03.2007.",
        ie: "Optimiert für Internet Explorer · Beste Auflösung 1024×768",
        points: [
          "Lädt 9 Sekunden — die Besucher sind längst woanders",
          "Am Handy unbedienbar — genau dort suchen Angehörige",
          "Kein einziges Vertrauenssignal, keine Bewertungen",
          "Kein klarer Weg zur Anfrage — das Telefon bleibt still",
        ],
      },
      good: {
        badge: "Nachher",
        url: "www.muster-pflegedienst.de",
        name: "Pflegedienst Musterpflege",
        headline: "Pflege, die man der eigenen Mutter anvertraut.",
        tag: "Pflege in Ihrer Region",
        cta2: "Unsere Leistungen",
        reviews: "4,9 · 128 Bewertungen",
        cta: "Beratung anfragen",
        phone: "0800 12 34 567",
        chips: ["Häusliche Pflege", "Tagespflege", "24 h erreichbar"],
        points: [
          "Lädt in unter einer Sekunde — auf jedem Gerät",
          "Mobile First: der Anruf-Button ist immer im Blick",
          "Bewertungen und Gesichter, die Vertrauen schaffen",
          "Ein Klick bis zur Anfrage — Anfragen statt Klicks",
        ],
      },
      cta: "Welche der beiden Seiten ruft man an?",
      ctaBtn: "Markt-Check anfragen",
    },
    eroeffnung: {
      eyebrow: "Spezial · Für Gründer",
      title: "Neu eröffnen? Wir bauen Marke und Fundament.",
      sub: "Viele Dienste scheitern nicht an der Pflege — sondern an Papier, Zulassung und Sichtbarkeit. Wir begleiten Ihre Eröffnung von den Krankenkassen bis zum ersten Patienten.",
      points: [
        { icon: "clipboard", title: "Zulassung § 71/72 SGB XI & § 132a SGB V", copy: "Krankenkassen, Versorgungsvertrag, Beratungsstelle — wir führen Sie durch den Behörden-Dschungel, der Eröffner sonst Monate kostet." },
        { icon: "shield", title: "QM-Handbuch ab Tag eins", copy: "Ein QM-Handbuch, das die Prüfung durch den Medizinischen Dienst (früher MDK) besteht — passend zu Ihrem Dienst, nicht aus der Schublade." },
        { icon: "monitor", title: "Marke & Sichtbarkeit vor Tag eins", copy: "Marke, Website, Google Maps und die ersten Anzeigen laufen, bevor Sie eröffnen — damit ab Tag eins das Telefon klingelt." },
        { icon: "package", title: "Erstausstattung & Begleitung", copy: "Flyer, Verträge, Ablage, Mitarbeiter-Gespräche — und ein Ansprechpartner, der die Branche kennt." },
      ],
      target: "Für",
      targets: ["Ambulante Dienste", "Tagespflegen", "Intensivpflege", "Betreuungskräfte § 43b"],
      pkgBadge: "Das Eröffnungspaket",
      pkgTitle: "Pflege-Homepage & Marken-Grundgerüst",
      pkgCopy: "Festpreis ab 1.990 €: Marken-Design, Mobile-First-Homepage, Google-Maps-Optimierung und DSGVO-Konformität — das digitale Fundament Ihrer Marke. Limitierte Kapazität pro Monat, damit jeder Dienst unsere volle Aufmerksamkeit bekommt.",
      pkgPrice: "ab 1.990 €",
      pkgUnit: "Festpreis · inkl. Marken-Grundgerüst",
      pkgCta: "Eröffnungspaket anfragen",
    },
    prozess: {
      eyebrow: "Unser Prozess",
      title: "Der 3-Schritte-Weg zur Pflege-Marke.",
      steps: [
        { k: "Analyse", copy: "Strategie & Pflege-Potenzial-Analyse: Wir prüfen Ihre Marke, Ihre Anfragenlage und Ihre Region — und sagen Klartext, was möglich ist." },
        { k: "Marken-Aufbau", copy: "Marken-Design & digitale Infrastruktur: Website, Google Business, Anzeigen und Systeme — alles in einem Erscheinungsbild." },
        { k: "Wachstum", copy: "Go-Live: Patientenzulauf, Mitarbeiter-Gewinnung und laufende Optimierung — Sie sehen es an Ihren Anfragen." },
      ],
    },
    stats: {
      items: [
        { n: "24h", l: "Antwort auf Ihre Anfrage" },
        { n: "661", l: "Pflege-Lernmodule produziert" },
        { n: "0", l: "Baukasten — alles maßgeschneidert" },
        { n: "100%", l: "Festpreise & klare Pläne" },
      ],
      quote: "„Ein Pflegedienst, der Menschen hilft, darf nicht aussehen wie eine Website von 2005. Wer beste Pflege bietet, muss auch als Nummer 1 wahrgenommen werden.“",
      author: "— Jean & Markus Dickie, Gründer",
    },
    packages: {
      eyebrow: "Investition",
      title: "Klare Bausteine. Klare Preise.",
      sub: "Der schnellste Einstieg — und immer erweiterbar. Jeder Baustein wird individuell auf Ihren Dienst zugeschnitten.",
      note: "Beispielpreise zur Orientierung — jedes Paket wird individuell auf Sie zugeschnitten. Alle Preise zzgl. MwSt.",
      popular: "Meist gebucht",
      cta: "Jetzt anfragen",
      enterpriseCta: "Kontakt aufnehmen",
      cards: [
        { id: "eroeffnung", name: "Eröffnungspaket", tag: "Für Gründer", price: "Festpreis", unit: "im Erstgespräch", features: ["Zulassung § 71/72 SGB XI & § 132a SGB V", "QM-Handbuch für die Prüfung durch den Medizinischen Dienst (früher MDK)", "Marke, Website & Google Maps Start", "Erstausstattung & Begleitung bis Tag eins"] },
        { id: "sichtbarkeit", name: "Marke & Homepage", tag: "Für die lokale Marke", price: "ab €1.990", unit: "einmalig · Festpreis", features: ["Marken-Design, das man wiedererkennt", "High-End Pflege-Homepage (Mobile First)", "Local SEO: sichtbar vorne bei Google & Maps", "Echte Bewertungen & Social Präsenz"] },
        { id: "wachstum", name: "Wachstums-Maschine", tag: "Für volle Touren", price: "ab €1.290", unit: "pro Monat", features: ["Google & Meta Ads: Patienten + Personal", "Monatliche Kampagnen & Optimierung", "Empfehlungsquellen systematisch aufbauen", "Monatliches Reporting: Anfragen sichtbar"] },
        { id: "systeme", name: "Systeme & QM", tag: "Für den ruhigen Betrieb", price: "ab €2.900", unit: "je nach Umfang", features: ["Anbindung der Abrechnungssoftware", "CRM für Anfragen & Zuweiser", "QM-Handbuch & Prüfung durch den Medizinischen Dienst (früher MDK)", "Laufender Jahres-Support"] },
      ],
    },
    auditPackage: {
      badge: "Der Pflege-Markt-Check",
      title: "Wo bleibt Ihre Marke — und wo bleiben die Anfragen?",
      copy: "Ein geübter Blick von außen: Wir prüfen Ihre Marke, Ihre Sichtbarkeit, Ihre Website und Ihre Region und liefern einen klaren Bericht — wo Sie unsichtbar sind und was zuerst zu tun ist.",
      price: "Festpreis",
      unit: "im Erstgespräch",
      cta: "Markt-Check anfragen",
    },
    branchen: {
      eyebrow: "Versorgungsformen",
      title: "Jede Versorgungsform. Ein Ziel: die Marke der Region.",
      sub: "Wir begleiten Pflegedienste jeder Form — Ihre Klientel ist anders, Ihr Weg zur bekannten Marke ist derselbe.",
      items: ["Ambulante Pflege", "Intensivpflege & 1:1-Betreuung", "Tagespflege & Wohngemeinschaften", "Stationäre Pflege & Residenzen"],
    },
    about: {
      eyebrow: "Warum Joudi",
      title: "Wir sind selbst Pflege. Kein Baukasten. Kein Blabla.",
      lead: "Joudi ist auf eine Branche spezialisiert: die Pflege. Wir haben selbst eine Pflege-Akademie von null aufgebaut — Kurse, Kostenträger, Fachbücher, Lernvideos. Wir wissen also genau, wie Zulassung, Eröffnung und Wachstum in dieser Branche wirklich laufen — und bauen genau das für Ihren Dienst.",
      principles: [
        { k: "Pflege vor Prozenten", copy: "Wir empfehlen nichts, was wir nicht aus der Branche kennen. Jedes Projekt beginnt mit einem ehrlichen Blick auf Ihre Marke, Ihre Anfragenlage und Ihre Region." },
        { k: "Feste Preise, klare Pläne", copy: "Keine versteckten Honorare und keine offenen Enden — Sie wissen vorab, was Sie bekommen und was es kostet." },
        { k: "Beratung, die umsetzt", copy: "Wir bleiben nicht bei Folien stehen: Wir bauen Marken, schalten Anzeigen, richten Systeme ein — und bleiben bis die Anfragen kommen." },
        { k: "Deutsch & Englisch, EU-Standards", copy: "Betreuung auf Deutsch und Englisch, gelebt zwischen Deutschland und Zypern — mit europäischem Qualitätsanspruch." },
      ],
      label: "Die Köpfe hinter Joudi",
      people: [
        { name: "Markus Dickie", role: "Geschäftsführer · Strategie & Pflegemärkte", line: "Fragt nach den Ursachen, nicht nach den Symptomen." },
        { name: "Jean Dickie", role: "Markenaufbau & Kundengewinnung Pflege", line: "Ihr direkter Draht — vom ersten Gespräch bis zur vollen Tour." },
      ],
      cta: "Lernen Sie uns kennen",
      refBadge: "Echte Referenz",
      refTitle: "Unsere eigene Pflege-Akademie: die Dickies-Campus GmbH.",
      refCopy: "Von null aufgebaut — Kurse, Kostenträger, Fachbücher, Lernvideos, Marke, Website. Was wir für Ihren Dienst versprechen, haben wir selbst schon einmal getan. Die Dickies-Campus GmbH ist der lebende Beweis.",
      refLink: "Projekt ansehen · dickies-helden.de",
    },
    faq: {
      eyebrow: "Häufige Fragen",
      title: "Gut zu wissen, bevor wir reden.",
      items: [
        { q: "Wir sind schon seit Jahren da — können Sie trotzdem helfen?", a: "Genau dafür sind wir da. Die meisten unserer Klienten existieren längst — ihnen fehlen Bekanntheit und Anfragen, nicht Können. Wir machen Ihren Dienst zur Marke der Region und füllen danach die Kalender." },
        { q: "Wie läuft ein Projekt mit Ihnen ab?", a: "Immer gleich: Erstgespräch, Pflege-Markt-Check, Festpreis-Angebot — dann Umsetzung mit klaren Meilensteinen. Sie wissen jederzeit, wo wir stehen." },
        { q: "Was kostet der Einstieg?", a: "Der schnellste Einstieg ist der Pflege-Markt-Check im Erstgespräch: ein Festpreis mit klarem Bericht. Die Pflege-Homepage startet bei 1.990 € Festpreis — alles Individuelle besprechen wir persönlich." },
        { q: "Kann ich auch nur einen Baustein beauftragen?", a: "Selbstverständlich: nur die Marke & Homepage, nur Google Ads, nur die Software-Anbindung — jeder Baustein ist modular erweiterbar." },
        { q: "Arbeiten Sie nur mit Pflegediensten?", a: "Unser Fokus liegt klar auf der Pflege — das ist unsere Branche. Andere Anfragen nehmen wir gern im Erstgespräch auf und sagen ehrlich, ob wir der richtige Partner sind." },
      ],
    },
    cta: {
      title: "Bereit für die Marke der Region?",
      sub: "Ein Gespräch. Der erste Schritt zu bekannter Marke und vollen Touren.",
      button: "Erstgespräch anfragen",
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Reden wir über Ihre Marke.",
      sub: "Drei kurze Schritte — wir melden uns innerhalb eines Werktags, unverbindlich und vertraulich.",
      points: ["Antwort innerhalb eines Werktags", "Pflege kennt Ihre Sprache", "Erstgespräch unverbindlich"],
      formTitle: "Anfrage für Ihren Dienst",
      stepOf: "Schritt {n} von 3",
      steps: ["Ihr Dienst", "Ihr Ziel", "Ihr Kontakt"],
      pflegedienst: "Name des Pflegedienstes",
      pflegedienstPlaceholder: "z. B. Pflegehof Musterstadt",
      city: "Stadt / Region",
      cityPlaceholder: "z. B. Erkrath, Kreis Mettmann",
      careType: "Versorgungsform",
      careTypePlaceholder: "Bitte wählen",
      careOptions: ["Ambulanter Dienst", "Tagespflege", "Intensivpflege", "Voll-/teilstationär", "Sonstige"],
      bottleneck: "Was ist Ihr Ziel?",
      bottleneckHint: "Ein Klick genügt — Feinheiten klären wir im Gespräch.",
      bottleneckOptions: ["Marke & Wiedererkennung", "Patienten-Anfragen", "Personal & Fachkräfte", "Homepage & Sichtbarkeit", "Abrechnung & Systeme", "QM & Zulassung"],
      message: "Was ist los? Kurz & ehrlich",
      messagePlaceholder: "z. B. Wir sind 14 Mitarbeiter, aber die Touren sind nicht voll …",
      name: "Ihr Name",
      email: "Ihre E-Mail",
      phone: "Telefon (für schnelle Rückfragen)",
      phonePlaceholder: "+49 …",
      next: "Weiter",
      back: "Zurück",
      summaryTitle: "Passt alles?",
      summaryEmpty: "Noch nichts ausgefüllt",
      submit: "Anfrage senden",
      sending: "Wird gesendet …",
      successToast: "Danke! Ihre Anfrage ist eingegangen — wir melden uns innerhalb eines Werktags.",
      errorToast: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
      pflegedienstRequired: "Bitte geben Sie den Namen Ihres Dienstes an.",
      cityRequired: "Bitte geben Sie Stadt oder Region an.",
      careTypeRequired: "Bitte wählen Sie die Versorgungsform.",
      bottleneckRequired: "Bitte wählen Sie Ihr Ziel.",
      nameRequired: "Bitte geben Sie Ihren Namen an.",
      emailRequired: "Bitte geben Sie eine gültige E-Mail-Adresse an.",
      phoneRequired: "Bitte geben Sie eine Telefonnummer an.",
      messageRequired: "Bitte schreiben Sie uns kurz Ihr Anliegen (min. 10 Zeichen).",
      stepIncomplete: "Bitte füllen Sie diesen Schritt vollständig aus.",
    },
    footer: {
      tagline: "Mehr Patienten. Mehr Personal. Eine echte Marke.",
      navTitle: "Navigation",
      legalTitle: "Rechtliches",
      imprint: "Impressum",
      privacy: "Datenschutz",
      motto: "Pflege / Marke / Wachstum",
      rights: "Alle Rechte vorbehalten.",
    },
  },
  en: {
    nav: {
      home: "Home",
      services: "Pillars",
      eroeffnung: "Launch",
      process: "Process",
      packages: "Investment",
      faq: "FAQ",
      industries: "Care types",
      contact: "Contact",
      cta: "Intro call",
      menuOpen: "Open menu",
      menuClose: "Close menu",
    },
    hero: {
      eyebrow: "Care brand building & growth",
      l1: "We turn your service",
      l2: "into the brand people know",
      l3: "and recognise.",
      l4: "More patients. More staff.",
      sub: "Every care service that helps people deserves a brand the region knows — and a calendar that is full. We build both: brand, website, Google & Meta ads, systems and QM. From one source. From people who built a care academy themselves from zero.",
      cta1: "Free potential analysis",
      cta2: "The four pillars",
      chips: ["Brand & recognition", "More patients", "More staff"],
      side: "Your brand. Your region. Your full schedules.",
      meta: "Paphos, Cyprus · German & English",
      imgAlt: "Care homepage on laptop and phone in a dark premium workspace",
      sim: {
        title: "Potential calculator",
        sub: "Where does your service stand today?",
        careType: "Care type",
        careOptions: ["Outpatient care", "Day care", "Intensive care", "In-/semi-residential"],
        city: "Catchment area",
        cityOptions: ["Small town (under 20,000)", "Mid-size town (20,000–75,000)", "City (over 75,000)"],
        current: "Enquiries per month today",
        currentHint: "An estimate is fine — you know your phone.",
        resultLabel: "Realistically possible with Joudi",
        resultHint: "An honest first estimate based on enquiries, region and care type. What your real numbers allow is clarified in the intro call — non-binding.",
        cta: "Discuss the potential",
        perMonth: "enquiries / month",
      },
    },
    marquee: ["Local care brand", "More patients", "Qualified staff", "Visible first on Google", "Representative website", "Systematic growth", "Brand building", "Full schedules"],
    services: {
      eyebrow: "The four pillars",
      title: "From unknown service to a real care brand.",
      sub: "Each pillar can be booked on its own — together they form your complete growth system. The bottleneck first, the rest after.",
      more: "Enquire about this pillar",
      items: [
        { id: "marke", icon: "monitor", title: "Brand building & regional visibility", desc: "People must know you and recognise you: one face, one name, one look — omnipresent in your region, at the top of Google.", checks: ["Brand design people recognise", "Visible at the top of Google in your region — Google Business & Maps", "A system for a steady flow of genuine reviews from happy relatives", "Social media that reaches your region"] },
        { id: "patienten", icon: "megaphone", title: "New patient growth & capacity", desc: "Your bottleneck is not care capacity — it is enquiries. We capture the searches of relatives and grow your referrer sources.", checks: ["Google & Meta ads for patient enquiries", "Referral sources: doctors, clinics, social stations", "Landing pages that bring calls, not clicks", "Enquiry tracking: you see what arrives"] },
        { id: "personal", icon: "users", title: "Staff recruiting & employer brand", desc: "No staff, no growth. Same machine, second audience: we make your service the attractive employer in your region.", checks: ["Staff campaigns for care professionals", "An employer brand people stay for", "Career page & application flow that convert", "Visibility wherever professionals search"] },
        { id: "systeme", icon: "database", title: "Systems, digitalisation & QM", desc: "Full calendars need smooth processes behind them — and an audit you pass with ease.", checks: ["Integration of your billing software", "CRM for enquiries, relatives & referrers", "Digital case files instead of paper stacks", "QM handbook & audit by the Medizinischer Dienst (formerly MDK)"] },
      ],
    },
    vergleich: {
      eyebrow: "Before / After",
      title: "A good care website is obvious at a glance. Unfortunately, so is a bad one.",
      sub: "80% of relatives search for a care service on their phone — and decide within seconds. The difference between these two pages is the difference between a silent phone and full schedules.",
      note: "All homepages shown are fictional examples for illustration.",
      bad: {
        badge: "Before",
        url: "www.beispiel-pflegedienst.de",
        name: "Pflegedienst Mustermann",
        headline: "A very warm welcome to our homepage!!!",
        welcome: "Nice to see you here",
        counter: "Visitors: 004217",
        neu: "NEW!",
        nav: ["Home", "About us", "Contact", "Guestbook"],
        body: "We are a care service offering home care, companionship, respite care, household help and much more. Click through our site to learn more about our services. Our site is still under construction. Last update: 12 March 2007.",
        ie: "Optimised for Internet Explorer · Best at 1024×768 resolution",
        points: [
          "Takes 9 seconds to load — visitors are long gone",
          "Unusable on mobile — exactly where relatives search",
          "Not a single trust signal, no reviews",
          "No clear path to an enquiry — the phone stays silent",
        ],
      },
      good: {
        badge: "After",
        url: "www.muster-pflegedienst.de",
        name: "Pflegedienst Musterpflege",
        headline: "Care you would trust with your own mother.",
        tag: "Care in your region",
        cta2: "Our services",
        reviews: "4.9 · 128 reviews",
        cta: "Request a consultation",
        phone: "0800 12 34 567",
        chips: ["Home care", "Day care", "Available 24 h"],
        points: [
          "Loads in under a second — on every device",
          "Mobile first: the call button is always in sight",
          "Reviews and faces that build trust",
          "One click to an enquiry — enquiries, not clicks",
        ],
      },
      cta: "Which of the two pages would you call?",
      ctaBtn: "Enquire about the market check",
    },
    eroeffnung: {
      eyebrow: "Special · For founders",
      title: "Launching? We build brand and foundation.",
      sub: "Many services do not fail at care — they fail at paperwork, licensing and visibility. We guide your launch from the health insurers to the first patient.",
      points: [
        { icon: "clipboard", title: "Licensing § 71/72 SGB XI & § 132a SGB V", copy: "Health insurers, care contract, advisory office — we guide you through the bureaucracy that otherwise costs founders months." },
        { icon: "shield", title: "QM handbook from day one", copy: "A QM handbook that passes the audit by the Medizinischer Dienst (formerly MDK) — tailored to your service, not off the shelf." },
        { icon: "monitor", title: "Brand & visibility before day one", copy: "Brand, website, Google Maps and the first ads run before you open — so the phone rings from day one." },
        { icon: "package", title: "Setup & accompaniment", copy: "Flyers, contracts, records, staff conversations — and a contact who knows the industry." },
      ],
      target: "For",
      targets: ["Outpatient services", "Day care", "Intensive care", "Care staff § 43b"],
      pkgBadge: "The launch package",
      pkgTitle: "Care homepage & brand foundation",
      pkgCopy: "Fixed price from €1,990: brand design, mobile-first homepage, Google Maps optimisation and GDPR compliance — the digital foundation of your brand. Limited capacity per month so every service gets our full attention.",
      pkgPrice: "from €1,990",
      pkgUnit: "fixed price · incl. brand foundation",
      pkgCta: "Enquire about the launch package",
    },
    prozess: {
      eyebrow: "Our process",
      title: "The 3-step path to a care brand.",
      steps: [
        { k: "Analysis", copy: "Strategy & care potential analysis: we review your brand, your enquiry situation and your region — and give you a straight answer on what is possible." },
        { k: "Brand building", copy: "Brand design & digital infrastructure: website, Google Business, ads and systems — all in one look." },
        { k: "Growth", copy: "Go-live: patient inflow, staff acquisition and ongoing optimisation — you see it in your enquiries." },
      ],
    },
    stats: {
      items: [
        { n: "24h", l: "Response to your enquiry" },
        { n: "661", l: "Care learning modules produced" },
        { n: "0", l: "Templates — everything bespoke" },
        { n: "100%", l: "Fixed prices, clear plans" },
      ],
      quote: "“A care service that helps people must not look like a 2005 website. Those who offer the best care must also be perceived as number one.”",
      author: "— Jean & Markus Dickie, Founders",
    },
    packages: {
      eyebrow: "Investment",
      title: "Clear pillars. Clear prices.",
      sub: "The fastest way to start — always expandable. Every pillar is tailored to your service individually.",
      note: "Sample pricing for orientation — every pillar is tailored to you individually. All prices excl. VAT.",
      popular: "Most booked",
      cta: "Request now",
      enterpriseCta: "Get in touch",
      cards: [
        { id: "eroeffnung", name: "Launch package", tag: "For founders", price: "Fixed price", unit: "in the intro call", features: ["Licensing § 71/72 SGB XI & § 132a SGB V", "QM handbook for the audit by the Medizinischer Dienst (formerly MDK)", "Brand, website & Google Maps start", "Setup & accompaniment until day one"] },
        { id: "sichtbarkeit", name: "Brand & homepage", tag: "For the local brand", price: "from €1,990", unit: "one-time · fixed price", features: ["Brand design people recognise", "High-end care homepage (mobile first)", "Local SEO: visible first on Google & Maps", "Genuine reviews & social presence"] },
        { id: "wachstum", name: "Growth engine", tag: "For full schedules", price: "from €1,290", unit: "per month", features: ["Google & Meta ads: patients + staff", "Monthly campaigns & optimisation", "Referral sources built systematically", "Monthly reporting: enquiries visible"] },
        { id: "systeme", name: "Systems & QM", tag: "For calm operations", price: "from €2,900", unit: "depending on scope", features: ["Billing software integration", "CRM for enquiries & referrers", "QM handbook & audit by the Medizinischer Dienst (formerly MDK)", "Ongoing annual support"] },
      ],
    },
    auditPackage: {
      badge: "The care market check",
      title: "Where is your brand — and where are the enquiries?",
      copy: "One experienced outside perspective: we review your brand, your visibility, your website and your region and deliver a clear report — where you are invisible and what to do first.",
      price: "Fixed price",
      unit: "in the intro call",
      cta: "Request the market check",
    },
    branchen: {
      eyebrow: "Care types",
      title: "Every care type. One goal: the region's brand.",
      sub: "We support care services of every form — your clients differ, your path to a known brand is the same.",
      items: ["Outpatient care", "Intensive care & 1:1 support", "Day care & shared flats", "Residential care & residences"],
    },
    about: {
      eyebrow: "Why Joudi",
      title: "We are care ourselves. No templates. No fluff.",
      lead: "Joudi specialises in one industry: care. We built a care academy ourselves from zero — courses, payers, specialist books, learning videos. We know exactly how licensing, launching and growing really work in this industry — and we build exactly that for your service.",
      principles: [
        { k: "Care before margins", copy: "We never recommend anything we don't know from the industry. Every project starts with an honest look at your brand, your enquiry situation and your region." },
        { k: "Fixed prices, clear plans", copy: "No hidden fees, no open ends — you know in advance what you get and what it costs." },
        { k: "Consulting that executes", copy: "We don't stop at slideware: we build brands, run ads, set up systems — and stay until the enquiries arrive." },
        { k: "German & English, EU standards", copy: "Support in German and English, lived between Germany and Cyprus — with a European quality standard." },
      ],
      label: "The people behind Joudi",
      people: [
        { name: "Markus Dickie", role: "Managing Director · Strategy & care markets", line: "Asks for causes, not symptoms." },
        { name: "Jean Dickie", role: "Brand building & care customer acquisition", line: "Your direct line — from first call to a full schedule." },
      ],
      cta: "Meet us in person",
      refBadge: "Real reference",
      refTitle: "Our own care academy: Dickies-Campus GmbH.",
      refCopy: "Built from zero — courses, payers, specialist books, learning videos, brand, website. What we promise your service, we have done ourselves. Dickies-Campus GmbH is the living proof.",
      refLink: "View project · dickies-helden.de",
    },
    faq: {
      eyebrow: "FAQ",
      title: "Good to know before we talk.",
      items: [
        { q: "We have been around for years — can you still help?", a: "That is exactly who we serve. Most of our clients already exist — what they lack is recognition and enquiries, not competence. We make your service the brand of the region and then fill the calendars." },
        { q: "How does a project with you work?", a: "Always the same: intro call, care market check, fixed-price proposal — then implementation with clear milestones. You always know where things stand." },
        { q: "What does an entry point cost?", a: "The fastest start is the care market check in the intro call: a fixed price with a clear report. The care homepage starts at €1,990 fixed price — anything individual we discuss in person." },
        { q: "Can I book single pillars only?", a: "Absolutely: brand & homepage only, Google ads only, software integration only — every pillar is modular and expandable." },
        { q: "Do you only work with care services?", a: "Our focus is clearly on care — that is our industry. Other enquiries are welcome in the intro call, and we will honestly say whether we are the right partner." },
      ],
    },
    cta: {
      title: "Ready to be the region's brand?",
      sub: "One conversation. The first step to a known brand and full schedules.",
      button: "Request an intro call",
    },
    contact: {
      eyebrow: "Contact",
      title: "Let's talk about your brand.",
      sub: "Three short steps — we will get back to you within one business day, non-binding and confidential.",
      points: ["Reply within one business day", "Care speaks your language", "Intro call is non-binding"],
      formTitle: "Enquiry for your service",
      stepOf: "Step {n} of 3",
      steps: ["Your service", "Your goal", "Your contact"],
      pflegedienst: "Name of your care service",
      pflegedienstPlaceholder: "e.g. Musterstadt Care Home",
      city: "City / region",
      cityPlaceholder: "e.g. Erkrath, Mettmann district",
      careType: "Care type",
      careTypePlaceholder: "Please select",
      careOptions: ["Outpatient service", "Day care", "Intensive care", "In-/semi-residential", "Other"],
      bottleneck: "What is your goal?",
      bottleneckHint: "One click is enough — we'll refine it in the call.",
      bottleneckOptions: ["Brand & recognition", "Patient enquiries", "Staff & professionals", "Homepage & visibility", "Billing & systems", "QM & licensing"],
      message: "What's going on? Short & honest",
      messagePlaceholder: "e.g. We have 14 staff, but the routes are not full …",
      name: "Your name",
      email: "Your email",
      phone: "Phone (for quick follow-up)",
      phonePlaceholder: "+49 …",
      next: "Next",
      back: "Back",
      summaryTitle: "All correct?",
      summaryEmpty: "Nothing filled in yet",
      submit: "Send enquiry",
      sending: "Sending …",
      successToast: "Thank you! Your enquiry has arrived — we will get back to you within one business day.",
      errorToast: "Something went wrong. Please try again.",
      pflegedienstRequired: "Please enter the name of your service.",
      cityRequired: "Please enter a city or region.",
      careTypeRequired: "Please select the care type.",
      bottleneckRequired: "Please select your goal.",
      nameRequired: "Please enter your name.",
      emailRequired: "Please enter a valid email address.",
      phoneRequired: "Please enter a phone number.",
      messageRequired: "Please tell us briefly what you need (min. 10 characters).",
      stepIncomplete: "Please complete this step fully.",
    },
    footer: {
      tagline: "More patients. More staff. A real brand.",
      navTitle: "Navigation",
      legalTitle: "Legal",
      imprint: "Imprint",
      privacy: "Privacy Policy",
      motto: "Care / Brand / Growth",
      rights: "All rights reserved.",
    },
  },
};
